import React from 'react';

const NotFound = () => (
    <>
        <h1 style={{ color: "white" }}>No encontrado</h1>
        <h2>Regresa al Home</h2>
    </>
)

export default NotFound;
